import { MARKS_GUIDE } from "#public"

/**
 * `hidden_guides` with every destination guide turned back on, the marks
 * keeping theirs — what a user adding a file gets: an upload is there to be
 * seen, even when the viewer opened with its layers hidden (a filecheck
 * link). Only for the user's own gesture: a link's files joining on mount
 * must leave the link's guides alone.
 */
export const ShowDestinations = (hidden_guides: string[]): string[] =>
  hidden_guides.filter(id => id === MARKS_GUIDE)
